import { getTimeByTimezoneFull } from 'app/utils/date'
import styles from './styles.module.scss'
import { useSelector } from 'react-redux'

const getTexts = ({ widgetData }) => widgetData.widgetInfo.languageInfo.texts
const getLanguage = ({ widgetData }) => widgetData.widgetInfo.languageInfo.general.language

function DateDivider({ date }) {
  const texts = useSelector(getTexts)

  const getDateForDivider = () => {
    const language = useSelector(getLanguage)

    const dateObj = new Date(date)
    const timestamp = new Date(date).valueOf()

    const dt = new Date(timestamp)
    const dateNum = dt.getDate()
    const diffDays = new Date().getDate() - dateNum
    const diffMonths = new Date().getMonth() - dt.getMonth()
    const diffYears = new Date().getFullYear() - dt.getFullYear()

    // Check if inputDate is today or yesterday
    if (diffYears === 0 && diffDays === 0 && diffMonths === 0) {
      return texts.today
    } else if (diffYears === 0 && diffDays === 1) {
      return texts.yesterday
    }

    if (language === 'en') {
      const dateObj = new Date(date)
      const options = { day: 'numeric', month: 'long' }
      const formattedDate = dateObj.toLocaleDateString('en-GB', options)

      return formattedDate
    }

    // Format the date as YYYY-MM-DD
    return getTimeByTimezoneFull(dateObj)
  }

  return (
    <p className={styles.date_wrapper}>
      <span className={styles.divider} />
      <span className={styles.date}>{getDateForDivider()}</span>
      <span className={styles.divider} />
    </p>
  )
}

export default DateDivider
